import React from 'react';

import { Layout } from 'antd';
import NotifContextProvider from '../Components/Context/NotifContext';
import ThemeContextProvider from '../Components/Context/ThemeContext';
import ProfileContextProvider from '../Components/Context/ProfileContext';
import ExploreContextProvider from '../Components/Context/ExploreContext';

import ExploreHeader from '../Components/Header/ExploreHeader';
import ExploreFeed from '../Components/Feed/ExploreFeed';
import ProfileDrawer from '../Components/Drawer/ProfileView';

export default function Artile(props) {
    return (
        <div>
            <ThemeContextProvider>
                <NotifContextProvider>
                    <ProfileContextProvider>
                        <ExploreContextProvider>
                            <Layout>
                                <ExploreHeader />
                                <ExploreFeed />
                                <ProfileDrawer />
                            </Layout>
                        </ExploreContextProvider>
                    </ProfileContextProvider>
                </NotifContextProvider>
            </ThemeContextProvider>
        </div>
    );
}
